import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface OneWayMessageEntityParams {
  message_id?: number;
  was_read?: boolean;
}
export class OneWayMessageEntity extends BaseEntityClass {
  message_id?: number;
  was_read?: boolean;
  constructor(params: OneWayMessageEntityParams) {
    super();
    this.type = "one_way_message";
    this.entity_version = 1;
    this.message_id = params.message_id;
    this.was_read = params.was_read;
  }
}
